import Icon from '../components/Icon.vue'

Icon.register({
  'place-of-worship': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M620.6 366.6L512 320V512H624C632.8 512 640 504.8 640 496V396A32-32 0 0 1 620.6 366.5zM0 396V496C0 504.8 7.2 512 16 512H128V320L19.4 366.6A32-32 0 0 1 0 396zM464.5 246.7L416 217.6V102.6C416 94.1 412.6 86 406.6 80L331.3 4.7C325.1-1.6 314.9-1.6 308.7 4.7L233.4 80C227.4 86 224 94.1 224 102.6V217.6L175.5 246.7A32-32 0 0 1 160 274.1V512H256V416C256 380.6 284.7 352 320 352S384 380.6 384 416V512H480V274.1C480 262.9 474.1 252.5 464.5 246.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/place-of-worship.js
// module id = TVx3
// module chunks = 144